import {debounce} from 'lodash';
import {datastageApi} from '../../../api';

/**
 * Fetches product options with a debounce to reduce API calls.
 */
export const fetchProductOptions = debounce(
    async (sectionId, inputValue, callback, updateLinkedProducts) => {
        try {
            const response = await datastageApi.products(
                {sectionIdForProductsToExclude: sectionId, hasClearanceMemo: true, q: inputValue},
                [0, 24],
                ['productTitle', 'ASC'],
            );

            const products =
                response?.content?.map(({productTitle, productId}) => ({
                    label: productTitle,
                    value: productId,
                })) ?? [];

            updateLinkedProducts({productOptions: products});
            callback(products);
        } catch (error) {
            console.error('Failed to load product options:', error);
            callback([]);
        }
    },
    300,
);

/**
 * Fetches linked products data for a specific page.
 *
 * @param {string} sectionId - The ID of the section to fetch products for.
 * @param {Array} range - The range of items to fetch.
 * @param {Object} dateAddedMap - Map of product IDs to their added dates.
 * @param {Object} unconfirmedProductIdList - List of unconfirmed product IDs.
 * @returns {Object} - The linked products data.
 */
export const fetchLinkedProducts = async (
    sectionId,
    range,
    sortParam,
    dateAddedMap,
    unconfirmedProductIdList,
) => {
    const data = await datastageApi.linkedProducts(
        {sectionIdForProductsToInclude: sectionId},
        range,
        sortParam
    );

    const linkedProducts = data?.content?.map((product) => ({
        ...product,
        addedDate: dateAddedMap?.[product.productId] || '',
        verified: unconfirmedProductIdList?.[product.productId] ? 'No' : 'Yes',
        isLinked: true,
    }));

    return {
        linkedProducts,
        totalPages: data?.totalPages,
        currentPage: data?.pageable.pageNumber,
        rangeParam: range,
        sortParam: sortParam,
        totalItems: data?.totalElements,
    };
};

export const fetchProducts = async (sectionId) => {
    try {

        const productData = await
            datastageApi.products(
                {sectionIdForProductsToExclude: sectionId, hasClearanceMemo: true},
                [0, 24],
                ['productTitle', 'ASC'],
            );


        const productOptions = (productData?.content ?? []).map(({productTitle, id}) => ({
            label: productTitle,
            value: id,
        }));


        return {productOptions};
    } catch (error) {
        console.error('Error fetching products:', error);
        return {
            productOptions: [],
        };
    }
};
